import React from 'react'
import '../../App.css'
import AboutAdventure from '../AboutAdventure';
import Footer from '../Footer';
function Adventure(){
    return(
        <>
        <AboutAdventure/>
        <Footer />
        </>
    )
}
export default Adventure;